import { render, staticRenderFns } from "./c_home_coupon.vue?vue&type=template&id=1a2a5601&scoped=true"
import script from "./c_home_coupon.vue?vue&type=script&lang=js"
export * from "./c_home_coupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a5601",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2a5601')) {
      api.createRecord('1a2a5601', component.options)
    } else {
      api.reload('1a2a5601', component.options)
    }
    module.hot.accept("./c_home_coupon.vue?vue&type=template&id=1a2a5601&scoped=true", function () {
      api.rerender('1a2a5601', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_coupon.vue"
export default component.exports